(() => {
  const normalize = value => value.toLocaleLowerCase('it').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  if (!customElements.get('mamata-faq')) {
    customElements.define('mamata-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.input = this.querySelector('input[type="search"]');
        this.items = [...this.querySelectorAll('[data-faq-item]')];
        this.groups = [...this.querySelectorAll('[data-faq-group]')];
        this.index = this.items.map(item => normalize(item.textContent));
        this.savedOpen = new Set();
        this.searching = false;
        this.input.addEventListener('input', () => this.filter());
        this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.filter(); });
        this.querySelectorAll('.mf-faq__categories a').forEach(link => link.addEventListener('click', event => {
          event.preventDefault(); this.input.value = ''; this.filter();
          const group = this.querySelector(link.getAttribute('href'));
          if (!group) return;
          group.scrollIntoView({ block: 'start', behavior: 'smooth' });
          const heading = group.querySelector('h2'); heading.tabIndex = -1; heading.focus({ preventScroll: true });
        }));
      }
      filter() {
        const tokens = normalize(this.input.value).split(/\s+/).filter(Boolean);
        if (tokens.length && !this.searching) this.savedOpen = new Set(this.items.filter(item => item.open));
        let count = 0;
        this.items.forEach((item, i) => {
          const match = tokens.every(token => this.index[i].includes(token));
          item.hidden = !match;
          if (tokens.length) item.open = match;
          else if (this.searching) item.open = this.savedOpen.has(item);
          if (match) count++;
        });
        this.groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some(item => !item.hidden); });
        const status = this.querySelector('.mf-faq__status');
        status.hidden = !tokens.length;
        status.textContent = count === 1 ? '1 risposta trovata' : `${count} risposte trovate`;
        this.querySelector('.mf-faq__empty').hidden = count > 0;
        this.searching = tokens.length > 0;
      }
    });
  }
  if (!customElements.get('mamata-help')) {
    customElements.define('mamata-help', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.launcher = this.querySelector('.mf-help-launcher');
        this.scroller = this.querySelector('.mf-help__body');
        this.launcher.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || !this.dialog.showModal) return;
          event.preventDefault();
          this.returnFocus = document.activeElement;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.launcher.setAttribute('aria-expanded', 'true');
          this.querySelector('.mf-help__close').focus();
        });
        this.querySelector('.mf-help__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.dialog.close(); return; }
          if (event.key === 'Tab') {
            const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && element.tabIndex >= 0);
            const first = focusable[0], last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
            event.stopPropagation();
          }
        }, true);
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.launcher.setAttribute('aria-expanded', 'false');
          this.returnFocus?.focus({ preventScroll: true });
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.querySelectorAll('[data-help-view]').forEach(button => button.addEventListener('click', () => {
          const view = button.dataset.helpView;
          this.querySelectorAll('[data-help-panel]').forEach(panel => { panel.hidden = panel.dataset.helpPanel !== view; });
          this.querySelectorAll('.mf-help__nav button').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.helpView === view)));
          this.scroller.scrollTop = 0;
          if (view === 'faq') this.querySelector('[data-help-panel="faq"] input').focus({ preventScroll: true });
          else this.querySelector(`.mf-help__nav [data-help-view="${view}"]`).focus({ preventScroll: true });
        }));
        // The unpublished theme's Shopify preview bar must not cover assistance.
        // Only its outer frame geometry is inspected, never the frame's contents.
        this.updatePreviewOffset = () => {
          const frame = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
          const rect = frame?.getBoundingClientRect();
          const height = rect && rect.width > 0 && rect.height > 0 && rect.top < innerHeight && getComputedStyle(frame).visibility !== 'hidden' ? Math.max(0, innerHeight - rect.top) : 0;
          this.style.setProperty('--mf-preview-offset', `${Math.min(height, 160)}px`);
          document.documentElement.style.setProperty('--mf-preview-height', `${Math.min(height, 160)}px`);
        };
        this.previewObserver = new MutationObserver(() => this.updatePreviewOffset());
        this.previewObserver.observe(document.body, { childList: true });
        this.resizeObserver = new ResizeObserver(() => this.updatePreviewOffset());
        const observeFrame = () => {
          const frame = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
          if (frame && frame !== this.previewFrame) {
            this.previewFrame = frame; this.resizeObserver.observe(frame);
            this.frameObserver?.disconnect();
            this.frameObserver = new MutationObserver(() => this.updatePreviewOffset());
            this.frameObserver.observe(frame, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
          }
          this.updatePreviewOffset();
        };
        this.previewObserver.disconnect();
        this.previewObserver = new MutationObserver(observeFrame);
        this.previewObserver.observe(document.body, { childList: true });
        window.addEventListener('resize', this.updatePreviewOffset);
        observeFrame();
      }
      disconnectedCallback() {
        this.previewObserver?.disconnect(); this.frameObserver?.disconnect(); this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.updatePreviewOffset);
        if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
      }
    });
  }
})();
